(function () {
    'use strict';
  
    function getStorageKey() {
      return window.__ck_customer_id
        ? 'ck_wishlist_' + window.__ck_customer_id
        : 'ck_wishlist_guest';
    }
  
    var Wishlist = {
      _key: null,
  
      init: function () {
        this._key = getStorageKey();
        if (window.__ck_customer_id) {
          var guestItems = this._read('ck_wishlist_guest');
          if (guestItems.length) {
            var merged = this._read(this._key);
            guestItems.forEach(function (item) {
              if (!merged.find(function (i) { return i.id === item.id; })) merged.push(item);
            });
            this._write(this._key, merged);
            localStorage.removeItem('ck_wishlist_guest');
          }
        }
      },
  
      _read: function (key) {
        try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
      },
  
      _write: function (key, data) {
        try { localStorage.setItem(key, JSON.stringify(data)); } catch (e) {}
      },
  
      getAll: function () { return this._read(this._key); },
  
      get: function (productId) {
        return this.getAll().find(function (i) { return i.id === productId; }) || null;
      },
  
      add: function (item) {
        var list = this.getAll();
        if (!list.find(function (i) { return i.id === item.id; })) {
          list.push(item);
          this._write(this._key, list);
        }
      },
  
      remove: function (productId) {
        this._write(this._key, this.getAll().filter(function (i) { return i.id !== productId; }));
      },
  
      setVariant: function (productId, variantId) {
        var list = this.getAll();
        var item = list.find(function (i) { return i.id === productId; });
        if (item) {
          item.selected_variant_id = variantId;
          this._write(this._key, list);
        }
      },

      markLaunched: function (productId, variants) {
        var list = this.getAll();
        var item = list.find(function (i) { return i.id === productId; });
        if (item) {
          if (variants) item.variants = variants;
          item.preview = '';
          this._write(this._key, list);
        }
      },
  
      has: function (productId) {
        return !!this.getAll().find(function (i) { return i.id === productId; });
      },
  
      count: function () { return this.getAll().length; }
    };
  
    function formatMoney(cents) {
      var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '{{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{amount[^}]*\}\}/, amount);
    }
  
    // Returns variant ID to use for cart add (selected or first available)
    function resolveVariantId(item) {
      if (item.selected_variant_id) return item.selected_variant_id;
      if (item.variants && item.variants.length) {
        var available = item.variants.find(function (v) { return v.available; });
        return available ? available.id : item.variants[0].id;
      }
      return null;
    }

    // True when the item has variant data and every variant is unavailable.
    function isItemSoldOut(item) {
      return !!(item.variants && item.variants.length > 0 && item.variants.every(function (v) { return !v.available; }));
    }

    // Locked while item.preview (a unix ts, seconds) is set — cleared by the live refresh once
    // launched, so we never buy against the stale locked snapshot captured before launch.
    function isPreviewLocked(item) {
      return !!(item && parseInt(item.preview, 10) > 0);
    }

    // True once a locked item's launch time has passed and it needs a live refresh.
    function isPreviewLaunched(item) {
      var ts = item && parseInt(item.preview, 10);
      return !!(ts && ts * 1000 <= Date.now());
    }

    // Guards against firing duplicate fetches for the same product across re-renders.
    var _launchRefreshInFlight = {};

    // Fetch live data once for each item whose preview window has ended, so its button reflects
    // real stock. Failures leave the item locked and are retried on the next render.
    function refreshLaunchedPreviewItems(onUpdated) {
      var pending = Wishlist.getAll().filter(function (item) {
        return item.handle && isPreviewLaunched(item) && !_launchRefreshInFlight[item.id];
      });
      pending.forEach(function (item) {
        _launchRefreshInFlight[item.id] = true;
        fetch('/products/' + item.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            delete _launchRefreshInFlight[item.id];
            // Only re-render on success; a failed fetch leaves the item locked for the next render.
            if (product && product.variants) {
              Wishlist.markLaunched(item.id, product.variants);
              if (onUpdated) onUpdated();
            }
          })
          .catch(function () {
            delete _launchRefreshInFlight[item.id];
          });
      });
    }

    // True when the item's *selected* variant is available.
    // For items with no stored selection, falls back to any-available check.
    // Used by updateFooter and addAllToCart so the footer state and batch add
    // respect what the user explicitly picked, not just whether any variant exists.
    function isSelectedAvailable(item) {
      if (isPreviewLocked(item)) return false;
      if (item.selected_variant_id && item.variants && item.variants.length) {
        var sel = item.variants.find(function (v) { return v.id === item.selected_variant_id; });
        if (sel) return sel.available;
      }
      return !isItemSoldOut(item);
    }

    // Returns the variant ID for "Add All to Cart".
    // Honours the user's selection: if a specific variant is stored and sold out, returns null
    // so that item is skipped rather than silently swapped to a different size.
    // Only falls back to first-available when no selection was stored at all.
    function resolveAddAllVariantId(item) {
      if (item.selected_variant_id && item.variants && item.variants.length) {
        var sel = item.variants.find(function (v) { return v.id === item.selected_variant_id; });
        if (sel) return sel.available ? sel.id : null;
      }
      if (item.variants && item.variants.length) {
        var avail = item.variants.find(function (v) { return v.available; });
        return avail ? avail.id : null;
      }
      return item.selected_variant_id || null;
    }

    // Find the size/non-color option to show as picker
    function getSizeOption(item) {
      if (!item.options || !item.variants) return null;
      var colorNames = ['color', 'colour', 'farbe', 'couleur'];
      var result = null;
      item.options.forEach(function (opt, i) {
        if (result) return;
        if (opt.values.length === 1 && opt.values[0] === 'Default Title') return;
        if (colorNames.indexOf(opt.name.toLowerCase()) > -1) return;
        result = { option: opt, index: i };
      });
      return result;
    }
  
    function renderVariantPicker(item) {
      var sizeData = getSizeOption(item);
      if (!sizeData) return '';
  
      var opt = sizeData.option;
      var optKey = 'option' + (sizeData.index + 1);
      var selectedVariant = item.selected_variant_id
        ? (item.variants || []).find(function (v) { return v.id === item.selected_variant_id; })
        : null;
  
      var buttons = opt.values.map(function (value) {
        var matches = (item.variants || []).filter(function (v) { return v[optKey] === value; });
        var available = matches.some(function (v) { return v.available; });

        // Prefer a variant matching the current color/other options AND this size
        // (e.g. Orange+L not Red+L) so the selected combo stays color-consistent.
        var contextMatch = selectedVariant
          ? matches.find(function (v) {
              return (item.options || []).every(function (o, i) {
                if (i === sizeData.index) return true;
                return v['option' + (i + 1)] === selectedVariant['option' + (i + 1)];
              });
            })
          : null;
        var preferred = contextMatch || matches.find(function (v) { return v.available; }) || matches[0];
        var variantId = preferred ? preferred.id : null;
        var isSelected = selectedVariant ? selectedVariant[optKey] === value : false;

        var cls = 'ck-wishlist-variant-btn';
        if (isSelected) cls += ' ck-wishlist-variant-btn--selected';
        if (!available) cls += ' ck-wishlist-variant-btn--unavailable';

        return '<button type="button" class="' + cls + '" ' +
          'data-wishlist-variant-pick data-product-id="' + item.id + '" data-variant-id="' + variantId + '">' + value + '</button>';
      }).join('');
  
      return '<div class="ck-wishlist-item__variants">' + buttons + '</div>';
    }
  
    function addToCart(variantId, onSuccess, onError) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) { if (onError) onError(data); return; }
        if (onSuccess) onSuccess();
      })
      .catch(function () { if (onError) onError(); });
    }

    // Adds multiple line items to the cart in a single request.
    function addItemsToCart(lineItems, onSuccess, onError) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lineItems })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) { if (onError) onError(data); return; }
        if (onSuccess) onSuccess();
      })
      .catch(function () { if (onError) onError(); });
    }

    // Refresh header cart count bubble without opening the cart drawer.
    function refreshCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
            b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
          });
        });
    }
  
    var WishlistUI = {
      sidebar: null, overlay: null, counter: null, saleDot: null, itemsContainer: null, footer: null, atcAllBtn: null, atcAllMessage: null, guestHint: null,
      textAddedToCart: '', textEmpty: '', textAddToCart: '', textRemove: '', textAddToWishlist: '', textRemoveFromWishlist: '', textSaleBadge: '', textSoldOut: '', textComingSoon: '',

      init: function () {
        this.sidebar        = document.querySelector('[data-ck-wishlist-sidebar]');
        this.overlay        = document.querySelector('[data-ck-wishlist-overlay]');
        this.counter        = document.querySelector('[data-ck-wishlist-counter]');
        this.saleDot        = document.querySelector('[data-ck-wishlist-sale-dot]');
        this.itemsContainer = document.querySelector('[data-ck-wishlist-items]');
        this.footer         = document.querySelector('[data-ck-wishlist-footer]');
        this.atcAllBtn      = document.querySelector('[data-ck-wishlist-atc-all]');
        this.atcAllMessage  = document.querySelector('[data-ck-wishlist-atc-all-message]');
        this.guestHint      = document.querySelector('.ck-wishlist-guest-hint');

        if (!this.sidebar) return;

        this.textAddedToCart        = this.sidebar.dataset.textAddedToCart || '';
        this.textEmpty              = this.sidebar.dataset.textEmpty || '';
        this.textAddToCart          = this.sidebar.dataset.textAddToCart || '';
        this.textRemove             = this.sidebar.dataset.textRemove || '';
        this.textAddToWishlist      = this.sidebar.dataset.textAddToWishlist || '';
        this.textRemoveFromWishlist = this.sidebar.dataset.textRemoveFromWishlist || '';
        this.textSaleBadge          = this.sidebar.dataset.textSaleBadge || '';
        this.textSoldOut            = this.sidebar.dataset.textSoldOut || '';
        this.textComingSoon         = this.sidebar.dataset.textComingSoon || '';
  
        document.querySelectorAll('[data-ck-wishlist-close]').forEach(function (btn) {
          btn.addEventListener('click', WishlistUI.close.bind(WishlistUI));
        });
  
        if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
        if (this.atcAllBtn) this.atcAllBtn.addEventListener('click', function () {
          WishlistUI.addAllToCart();
        });
  
        document.querySelectorAll('[data-ck-wishlist-toggle]').forEach(function (btn) {
          btn.addEventListener('click', WishlistUI.open.bind(WishlistUI));
        });
  
        // Heart button click — add/remove from wishlist
        document.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-wishlist-btn]');
          if (!btn) return;
          e.preventDefault();
          var productId = parseInt(btn.dataset.productId, 10);

          if (Wishlist.has(productId)) {
            Wishlist.remove(productId);
            WishlistUI.updateAll();
            return;
          }

          // Multi-variant: open the pre-rendered picker modal if present
          var wishlistModal = document.getElementById('WishlistModal-' + productId);
          if (wishlistModal) {
            var ckEl = wishlistModal.querySelector('ck-quick-shop-compact');
            if (ckEl) ckEl.classList.remove('is-added');
            if (!wishlistModal._ckModalInstance && window.theme && theme.Modals) {
              wishlistModal._ckModalInstance = new theme.Modals('WishlistModal-' + productId, 'wishlist-modal-' + productId);
            }
            if (wishlistModal._ckModalInstance) wishlistModal._ckModalInstance.open();
            return;
          }

          // Single-variant or no modal: add directly
          var variants = null;
          var options = null;
          try { variants = JSON.parse(btn.dataset.productVariants || 'null'); } catch (e) {}
          try { options = JSON.parse(btn.dataset.productOptions || 'null'); } catch (e) {}
          // Read selected variant from the PDP's checked option inputs (most reliable — works for
          // sold-out variants too, since their radio is still checkable even though ATC is disabled).
          // Falls back to the data attribute (kept in sync by variant:change) then masterSelect.
          var selectedVariantId = null;
          var productSection = document.querySelector('.product-section[data-product-id="' + productId + '"]');
          if (productSection && variants) {
            var selectedOptions = [];
            productSection.querySelectorAll('[data-variant-input]').forEach(function (input) {
              var val = input.tagName === 'SELECT' ? input.value : (input.checked ? input.value : null);
              if (val) selectedOptions.push({ index: input.dataset.index, value: val });
            });
            if (selectedOptions.length) {
              var match = variants.find(function (v) {
                return selectedOptions.every(function (sel) {
                  var i = parseInt(sel.index.replace('option', ''), 10) - 1;
                  return v.options[i] === sel.value;
                });
              });
              if (match) selectedVariantId = match.id;
            }
          }
          if (!selectedVariantId) selectedVariantId = parseInt(btn.dataset.selectedVariantId, 10) || null;
          if (!selectedVariantId) {
            var masterSelect = document.querySelector('[data-product-id="' + productId + '"] [data-product-select]');
            if (masterSelect) selectedVariantId = parseInt(masterSelect.value, 10) || null;
          }
          Wishlist.add({
            id: productId,
            handle: btn.dataset.productHandle,
            title: btn.dataset.productTitle,
            price: parseInt(btn.dataset.productPrice, 10),
            compare_at_price: parseInt(btn.dataset.productComparePrice, 10) || 0,
            image: btn.dataset.productImage,
            url: btn.dataset.productUrl,
            variants: variants,
            options: options,
            selected_variant_id: selectedVariantId,
            preview: btn.dataset.productPreview || ''
          });
          WishlistUI.updateAll();
        });

        // Keep UI in sync when wishlist is changed outside this click handler
        // (e.g. cart "move to wishlist" flow).
        document.addEventListener('ck:wishlist:updated', function () {
          WishlistUI.updateAll();
          if (WishlistUI.sidebar && WishlistUI.sidebar.classList.contains('ck-wishlist-sidebar--open')) {
            WishlistUI.renderItems();
          }
        });

        // Re-apply active wishlist classes after section re-renders.
        document.addEventListener('shopify:section:load', function () {
          WishlistUI.updateButtons();
        });

        // Related products and recently viewed cards are loaded after the page is ready,
        // so their hearts must be synced once they are in the DOM.
        document.addEventListener('recommendations:loaded', function () {
          WishlistUI.updateButtons();
        });
        document.addEventListener('ck:cards:loaded', function () {
          WishlistUI.updateButtons();
        });

        // Keep selected variant in sync when user changes variant on product page.
        document.addEventListener('variant:change', function (e) {
          var variant = e.detail && e.detail.variant;
          if (!variant || !variant.id) return;
          if (!variant.product_id) return;
          document.querySelectorAll('[data-wishlist-btn][data-product-id="' + variant.product_id + '"]').forEach(function (btn) {
            btn.dataset.selectedVariantId = variant.id;
          });
        });

        this.updateAll();
      },
  
      open: function () {
        this.sidebar.classList.add('ck-wishlist-sidebar--open');
        if (this.overlay) this.overlay.classList.add('ck-wishlist-overlay--visible');
        document.body.style.overflow = 'hidden';
        this.renderItems();
      },
  
      close: function () {
        this.sidebar.classList.remove('ck-wishlist-sidebar--open');
        if (this.overlay) this.overlay.classList.remove('ck-wishlist-overlay--visible');
        document.body.style.overflow = '';
      },
  
      updateAll: function () {
        this.updateButtons();
        this.updateCounter();
        this.updateSaleDot();
      },
  
      updateButtons: function () {
        document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
          var inList = Wishlist.has(parseInt(btn.dataset.productId, 10));
          btn.classList.toggle('ck-wishlist-btn--active', inList);
          btn.setAttribute('aria-pressed', String(inList));
          btn.setAttribute('aria-label', inList ? WishlistUI.textRemoveFromWishlist : WishlistUI.textAddToWishlist);
        });
      },
  
      updateCounter: function () {
        if (!this.counter) return;
        var count = Wishlist.count();
        this.counter.textContent = count;
        this.counter.classList.toggle('ck-wishlist-counter--visible', count > 0);
      },
  
      updateSaleDot: function () {
        if (!this.saleDot) return;
        var hasSale = Wishlist.getAll().some(function (item) {
          return item.compare_at_price && item.compare_at_price > item.price;
        });
        this.saleDot.classList.toggle('ck-wishlist-sale-dot', hasSale);
      },

      renderItems: function () {
        if (!this.itemsContainer) return;
        var items = Wishlist.getAll();
        if (this.footer) this.footer.hidden = items.length === 0;
        if (this.guestHint) this.guestHint.hidden = items.length === 0;
        if (!items.length) {
          this.itemsContainer.innerHTML = '<p class="ck-wishlist-empty">' + this.textEmpty + '</p>';
          return;
        }
  
        this.itemsContainer.innerHTML = items.map(function (item) {
          var onSale = item.compare_at_price && item.compare_at_price > item.price;
          var isSoldOut = isItemSoldOut(item);
          // Drive ATC button state from the selected variant's availability, not the whole product.
          // Falls back to all-sold-out check when there's no stored selection.
          var selectedV = item.selected_variant_id && item.variants
            ? item.variants.find(function (v) { return v.id === item.selected_variant_id; })
            : null;
          var isSelectedSoldOut = selectedV ? !selectedV.available : isSoldOut;
          // Preview ("coming soon") products aren't buyable yet — lock the button regardless of
          // stock and label it "Coming soon" instead of "Sold out".
          var isPreview = isPreviewLocked(item);
          var isDisabled = isSelectedSoldOut || isPreview;
          var atcLabel = isPreview
            ? (WishlistUI.textComingSoon || WishlistUI.textSoldOut)
            : (isSelectedSoldOut ? WishlistUI.textSoldOut : WishlistUI.textAddToCart);
          var imageEl = item.image
            ? '<img class="ck-wishlist-item__image" src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
            : '<div class="ck-wishlist-item__image-placeholder"></div>';
          return (
            '<div class="ck-wishlist-item" data-wishlist-item="' + item.id + '">' +
              '<div class="ck-wishlist-item__confirmed" aria-hidden="true">' +
                '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><polyline points="20 6 9 17 4 12"/></svg>' +
                '<span>' + WishlistUI.textAddedToCart + '</span>' +
              '</div>' +
              '<div class="ck-wishlist-item__content">' +
                '<a href="' + item.url + '">' + imageEl + '</a>' +
                '<div class="ck-wishlist-item__info">' +
                  '<p class="ck-wishlist-item__title"><a href="' + item.url + '">' + item.title + '</a></p>' +
                  '<p class="ck-wishlist-item__price' + (onSale ? ' ck-wishlist-item__price--sale' : '') + '">' +
                    formatMoney(item.price) +
                    (onSale ? '<span class="ck-wishlist-item__compare">' + formatMoney(item.compare_at_price) + '</span>' : '') +
                    (onSale ? '<span class="ck-wishlist-item__sale-badge">' + WishlistUI.textSaleBadge + '</span>' : '') +
                  '</p>' +
                  renderVariantPicker(item) +
                  '<div class="ck-wishlist-item__actions">' +
                    '<button type="button" class="ck-wishlist-item__add-to-cart' + (isDisabled ? ' ck-wishlist-item__add-to-cart--sold-out' : '') + '" data-wishlist-atc data-product-id="' + item.id + '"' + (isDisabled ? ' disabled' : '') + '>' + atcLabel + '</button>' +
                    '<button type="button" class="ck-wishlist-item__remove" data-wishlist-remove="' + item.id + '" aria-label="' + WishlistUI.textRemove + '"><svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" fill="currentColor" width="16" height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 3h3v1h-1v9l-1 1H4l-1-1V4H2V3h3V2a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1zM9 2H6v1h3V2zM4 13h7V4H4v9zm2-8H5v7h1V5zm1 0h1v7H7V5zm2 0h1v7H9V5z"/></svg></button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>'
          );
        }).join('');
  
        // Variant picker selection
        this.itemsContainer.querySelectorAll('[data-wishlist-variant-pick]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var productId = parseInt(btn.dataset.productId, 10);
            var variantId = parseInt(btn.dataset.variantId, 10);
            Wishlist.setVariant(productId, variantId);
            // Update button states without full re-render
            var container = btn.closest('[data-wishlist-item]');
            container.querySelectorAll('[data-wishlist-variant-pick]').forEach(function (b) {
              b.classList.remove('ck-wishlist-variant-btn--selected');
            });
            btn.classList.add('ck-wishlist-variant-btn--selected');
            // Update ATC button to reflect the newly selected variant's availability
            var item = Wishlist.get(productId);
            var pickedV = item && item.variants
              ? item.variants.find(function (v) { return v.id === variantId; })
              : null;
            var pickedPreview = isPreviewLocked(item);
            var pickedAvailable = pickedPreview ? false : (pickedV ? pickedV.available : false);
            var atcBtn = container.querySelector('[data-wishlist-atc]');
            if (atcBtn) {
              atcBtn.disabled = !pickedAvailable;
              atcBtn.classList.toggle('ck-wishlist-item__add-to-cart--sold-out', !pickedAvailable);
              atcBtn.textContent = pickedAvailable
                ? WishlistUI.textAddToCart
                : (pickedPreview ? (WishlistUI.textComingSoon || WishlistUI.textSoldOut) : WishlistUI.textSoldOut);
            }
            // Refresh footer so "Add All" enables/disables based on the new selection.
            WishlistUI.updateFooter();
          });
        });
  
        // Remove
        this.itemsContainer.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            Wishlist.remove(parseInt(btn.dataset.wishlistRemove, 10));
            WishlistUI.updateAll();
            WishlistUI.renderItems();
          });
        });
  
        // Individual add to cart
        this.itemsContainer.querySelectorAll('[data-wishlist-atc]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var productId = parseInt(btn.dataset.productId, 10);
            var item = Wishlist.get(productId);
            if (!item) return;
            if (isPreviewLocked(item)) return;
            var variantId = resolveVariantId(item);
  
            btn.disabled = true;
            btn.textContent = '...';
  
            var doAdd = function (vid) {
              addToCart(vid, function () {
                refreshCartCount();
                var wishlistItem = btn.closest('[data-wishlist-item]');
                if (wishlistItem) {
                  wishlistItem.classList.add('ck-wishlist-item--confirmed');
                  var confirmedEl = wishlistItem.querySelector('.ck-wishlist-item__confirmed');
                  if (confirmedEl) confirmedEl.removeAttribute('aria-hidden');
                }
                setTimeout(function () {
                  Wishlist.remove(productId);
                  WishlistUI.updateAll();
                  // Always rebuild cart content so it's fresh when opened later.
                  // ajaxProduct:added triggers buildCart() + open() in CartDrawer.
                  // Close immediately after if wishlist still has items so the
                  // drawer rebuilds silently (browser won't paint the open state).
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
                  if (Wishlist.count() > 0) {
                    document.dispatchEvent(new CustomEvent('cart:close'));
                    WishlistUI.renderItems();
                  } else {
                    WishlistUI.close();
                  }
                }, 600);
              }, function () {
                btn.disabled = false;
                btn.textContent = WishlistUI.textAddToCart;
              });
            };
  
            if (variantId) {
              doAdd(variantId);
            } else {
              // Fallback: fetch product to get variant
              fetch('/products/' + item.handle + '.js')
                .then(function (r) { return r.json(); })
                .then(function (product) {
                  var v = product.variants.find(function (v) { return v.available; }) || product.variants[0];
                  doAdd(v.id);
                })
                .catch(function () {
                  btn.disabled = false;
                  btn.textContent = WishlistUI.textAddToCart;
                });
            }
          });
        });

        this.updateFooter();

        // Launched preview items get a one-time live refresh, then re-render with real stock.
        refreshLaunchedPreviewItems(function () {
          WishlistUI.renderItems();
        });
      },

      // Toggle the "Add all to cart" button + out-of-stock message based on
      // whether any item has its *selected* variant available.
      updateFooter: function () {
        if (!this.atcAllBtn) return;
        var items = Wishlist.getAll();
        var hasAddable = items.some(isSelectedAvailable);
        this.atcAllBtn.disabled = !hasAddable;
        if (this.atcAllMessage) {
          this.atcAllMessage.hidden = !(items.length > 0 && !hasAddable);
        }
      },

      addAllToCart: function () {
        if (!this.atcAllBtn || this.atcAllBtn.disabled) return;

        // Only items whose selected variant is available are eligible.
        // Items with a sold-out selection are skipped — we don't silently swap to a different size.
        var addable = Wishlist.getAll().filter(isSelectedAvailable);
        var lineItems = [];
        var addedIds = [];
        addable.forEach(function (item) {
          var vid = resolveAddAllVariantId(item);
          if (vid) {
            lineItems.push({ id: vid, quantity: 1 });
            addedIds.push(item.id);
          }
        });
        if (!lineItems.length) return;

        var btn = this.atcAllBtn;
        var originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';

        addItemsToCart(lineItems, function () {
          refreshCartCount();
          addedIds.forEach(function (id) { Wishlist.remove(id); });
          WishlistUI.updateAll();
          btn.textContent = originalLabel;
          // Rebuild the cart drawer; close it immediately if items remain so it
          // refreshes silently — same pattern as the single-item ATC flow.
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          if (Wishlist.count() > 0) {
            document.dispatchEvent(new CustomEvent('cart:close'));
            WishlistUI.renderItems();
          } else {
            WishlistUI.close();
          }
        }, function () {
          btn.textContent = originalLabel;
          WishlistUI.updateFooter();
        });
      },

    };
  
    // "Add to wishlist" button inside the variant-picker modal
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-add]');
      if (!btn) return;

      var section = btn.closest('.product-section');
      if (!section) return;

      var productId = parseInt(section.dataset.productId, 10);
      var productHandle = section.dataset.productHandle || '';
      var ckEl = section.querySelector('ck-quick-shop-compact');

      // Resolve selected variant from checked radios + variant JSON
      var variantId = null;
      var variantJsonEl = section.querySelector('[data-variant-json]');
      if (variantJsonEl) {
        try {
          var variants = JSON.parse(variantJsonEl.textContent);
          var form = section.querySelector('.ck-qs-compact__form');
          if (form) {
            var checkedInputs = form.querySelectorAll('[data-variant-input]:checked');
            var selectedOptions = Array.from(checkedInputs).map(function (i) { return i.value; });
            var match = variants.find(function (v) {
              return selectedOptions.every(function (val, idx) { return v.options[idx] === val; });
            });
            if (match) variantId = match.id;
          }
        } catch (ex) {}
      }

      // Fallback to first available variant from element data
      if (!variantId && ckEl && ckEl.dataset.productVariants) {
        try {
          var allVariants = JSON.parse(ckEl.dataset.productVariants);
          var firstAvail = allVariants.find(function (v) { return v.available; }) || allVariants[0];
          if (firstAvail) variantId = firstAvail.id;
        } catch (ex) {}
      }

      var itemVariants = null;
      var itemOptions = null;
      if (ckEl) {
        try { itemVariants = JSON.parse(ckEl.dataset.productVariants || 'null'); } catch (ex) {}
        try { itemOptions = JSON.parse(ckEl.dataset.productOptions || 'null'); } catch (ex) {}
      }

      Wishlist.add({
        id: productId,
        handle: productHandle,
        title: (ckEl && ckEl.dataset.productTitle) || '',
        price: parseInt((ckEl && ckEl.dataset.productPrice) || 0, 10),
        compare_at_price: parseInt((ckEl && ckEl.dataset.productComparePrice) || 0, 10),
        image: (ckEl && ckEl.dataset.productImage) || '',
        url: (ckEl && ckEl.dataset.productUrl) || '',
        variants: itemVariants,
        options: itemOptions,
        selected_variant_id: variantId,
        preview: (ckEl && ckEl.dataset.productPreview) || ''
      });

      if (ckEl) ckEl.classList.add('is-added');
      WishlistUI.updateAll();

      // Auto-close the modal after showing the confirmation
      var modalEl = btn.closest('.modal');
      if (modalEl && modalEl._ckModalInstance) {
        setTimeout(function () { modalEl._ckModalInstance.close(); }, 1500);
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      Wishlist.init();
      WishlistUI.init();
    });
  })();